(function () {
    "use strict";

    angular.module("app.product").factory("ProductService", ProductService);

    ProductService.$inject = ["$http", "$q"];

    function ProductService($http, $q) {
        var service = {
            searchProduct: searchProduct,
            filter: filter,
            getFilterData: getFilterData,
            getLastAddedProducts: getLastAddedProducts,
            getRelatedProductList: getRelatedProductList
        };

        var serviceBase = "/";
        return service;

        function filter(filterParams) {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/Product/Filter", {
                    params: filterParams,
                })
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getFilterData(filterModel) {
            var deferred = $q.defer();
            $http
                .get(serviceBase + "api/Product/FilterData", {
                    params: filterModel
                })
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function searchProduct(searchKey) {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/Product/Search?searchKey=" + searchKey)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getLastAddedProducts() {
            var deferred = $q.defer();
            var url = "General/LastAddedProducts";

            $http.get(url).then(complete).catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getRelatedProductList(filterModel) {
            var deferred = $q.defer();
            var url = "/api/Product/GetRelatedProductList";
            $http
                .get(url, {
                    params: filterModel,
                })
                .then(getRelatedProductListComplete)
                .catch(getRelatedProductListFailed);

            function getRelatedProductListComplete(response) {
                deferred.resolve(response);
            }

            function getRelatedProductListFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();
